const HourUpdateModal = ({
  hourUpdateModalInfo,
  allocationPeriodText,
  saving,
  onCancel,
  onProceed,
  onComplete,
}) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-md">
        <h4 className="text-lg font-semibold mb-4 text-gray-800">Confirm Hour Update</h4>
        {hourUpdateModalInfo.type === 'lessThan' && (
          <p>
            You are about to save <strong>{hourUpdateModalInfo.hours} actual hours</strong>, which is less than the
            allotted {hourUpdateModalInfo.allotted} hours {allocationPeriodText}.
          </p>
        )}
        {hourUpdateModalInfo.type === 'equalTo' && (
          <p>
            You have entered <strong>{hourUpdateModalInfo.hours} actual hours</strong>, which matches the
            allotted {hourUpdateModalInfo.allotted} hours {allocationPeriodText}.
          </p>
        )}
        <p className="mt-2">
          Do you want to proceed with saving these hours, or would you like to mark the job as completed?
        </p>
        <div className="flex justify-end space-x-3 mt-4">
          <button
            onClick={onCancel}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 border border-gray-300 rounded-md shadow-sm hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400"
            disabled={saving}
          >
            Cancel
          </button>
          <button
            onClick={onProceed}
            className="px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            disabled={saving}
          >
            Proceed with Hour Update
          </button>
          <button
            onClick={onComplete}
            className="px-4 py-2 text-sm font-medium text-white bg-green-600 hover:bg-green-700 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
            disabled={saving}
          >
            Set to Completed
          </button>
        </div>
      </div>
    </div>
  );
};

export default HourUpdateModal;
